export const Logo = ({ size = 44 }) => (
  <img
    src="/assets/logo.png"
    alt="Rooted Business Advisors logo"
    width={size}
    height={size}
    style={{ borderRadius: "50%", display: "block" }}
  />
);
